import { Filters } from './filters.enum';

export class RoomFilter {
  public label: string;
  public filter: Filters;
  public active = false;
  public order: number;
  public disabled = false;
  public dependencies: Filters[];

  constructor(label: string, filterKey: Filters, order = null, dependencies?: Filters[]) {
    this.label = label;
    this.filter = filterKey;
    this.order = order;
    this.dependencies = dependencies || [];
  }
}

export const MEAL_RELATED_FILTERS: Filters[] = [
  Filters.ROOM_ONLY,
  Filters.BREAKFAST,
  Filters.FULL_BOARD,
  Filters.ALL_INCLUSIVE,
  Filters.HALF_BOARD,
];
